import styled from 'styled-components'
import PropTypes from 'prop-types'
import AlertComponent from '@mui/material/Alert'
import { useState, useCallback, useEffect } from 'react'

import {
  SLB,
  SLB90T,
  SLB50S,
  SLR,
  SLR90T,
  SLR50S,
  SO,
  SO90T,
  SO50S,
  SG,
  SG90T,
  SG50S
} from '../../colors'
import { getMargin, marginPropTypes } from '../../utils'

const MuiAlert = styled(AlertComponent)`
  &.MuiAlert-standardInfo {
    background-color: ${SLB90T};

    .MuiAlert-icon {
      color: ${SLB};
    }

    .MuiAlert-message,
    .MuiIconButton-colorInherit {
      color: ${SLB50S};
    }
  }

  &.MuiAlert-standardError {
    background-color: ${SLR90T};

    .MuiAlert-icon {
      color: ${SLR};
    }

    .MuiAlert-message,
    .MuiIconButton-colorInherit {
      color: ${SLR50S};
    }
  }

  &.MuiAlert-standardWarning {
    background-color: ${SO90T};

    .MuiAlert-icon {
      color: ${SO};
    }

    .MuiAlert-message,
    .MuiIconButton-colorInherit {
      color: ${SO50S};
    }
  }

  &.MuiAlert-standardSuccess {
    background-color: ${SG90T};

    .MuiAlert-icon {
      color: ${SG};
    }

    .MuiAlert-message,
    .MuiIconButton-colorInherit {
      color: ${SG50S};
    }
  }
  button.MuiButtonBase-root {
    border: 1px solid transparent;
    &:focus,
    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
      border: 1px solid #aaa;
    }
  }
  cursor: ${({ onClick }) => (typeof onClick === 'function' ? 'pointer' : 'auto')};
  width: ${({ width }) => width};
  ${getMargin};
`
const Alert = ({
  onClose,
  onClick,
  message = '',
  isVisible = true,
  isDismissible = true,
  width = 'auto',
  type = 'info',
  ...rest
}) => {
  const [visible, setVisible] = useState(isVisible)
  const handleOnClose = useCallback(
    evt => {
      if (typeof onClose === 'function') {
        if (typeof onClick === 'function') {
          evt.stopPropagation()
        }

        onClose(evt)
      } else {
        setVisible(false)
      }
    },
    [onClose, onClick]
  )

  useEffect(() => {
    setVisible(isVisible)
  }, [isVisible])

  if (!visible) {
    return null
  }

  return (
    <MuiAlert
      severity={type}
      onClick={onClick}
      onClose={isDismissible ? handleOnClose : undefined}
      width={width}
      {...rest}>
      {message}
    </MuiAlert>
  )
}

Alert.propTypes = {
  ...marginPropTypes,
  /** Whether the alert is visible */
  isVisible: PropTypes.bool,
  /** Whether the alert can be closed */
  isDismissible: PropTypes.bool,
  /** The content to show inside the alert */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** How the alert should be styled */
  type: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  /** Callback when user clicks to close the alert */
  onClose: PropTypes.func,
  /** Callback when user clicks the body of the alert (not the close icon) */
  onClick: PropTypes.func,
  /** The width of the alert */
  width: PropTypes.string
}

export { Alert }
